import React, { HTMLProps, useState } from "react";
import "./index.css";
import { checkRequiredInput } from "./functions";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

interface inputProps extends HTMLProps<HTMLInputElement> {
  placeholder?: string;
  label?: string;
  type?: string;
  id?: string;
  ref?: any;
  className?: string;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  senha?: boolean;
  senhaVisivel?: boolean;
  onAlternarVisibilidadeSenha?: () => void;
  table?: boolean;
}

export const Input = ({
  placeholder,
  label,
  type,
  id,
  className,
  required,
  onChange,
  senha,
  senhaVisivel,
  onAlternarVisibilidadeSenha,
  table,
  ...rest
}: inputProps) => {
  const [changeClassRequired, setChangeClassRequired] = useState<string>(
    className ? className : "form-control"
  );
  const [requiredInput, setRequiredInput] = useState("");
  const [styleRequired, setStyleRequired] = useState<any>({});
  const [passwordShown, setPasswordShown] = useState(false);
  const passwordIsVisible = senhaVisivel ?? passwordShown;

  const handlePasswordVisibility = () => {
    if (onAlternarVisibilidadeSenha) {
      onAlternarVisibilidadeSenha();
      return;
    }

    setPasswordShown((visible) => !visible);
  };

  return (
    <div className={`input-container ${table ? "input-table" : ""} ${type === "file" ? "file-input" : ""}`}>
      <div className="input-wrapper">
        <input
          id={id}
          type={passwordIsVisible ? "text" : type || "text"}
          onChange={(e: any) => {
            onChange && onChange(e);
            checkRequiredInput(e.target.value, setChangeClassRequired, setRequiredInput, setStyleRequired, className);
          }}
          className={`${changeClassRequired} ${type === "file" ? "file-input" : ""}`}
          placeholder={placeholder + requiredInput}
          style={styleRequired}
          {...rest}
        />
        {senha && (
          <button
            type="button"
            onClick={handlePasswordVisibility}
            className="eye-button"
            aria-label={passwordIsVisible ? "Ocultar senhas" : "Mostrar senhas"}
            aria-pressed={passwordIsVisible}
            title={passwordIsVisible ? "Ocultar senhas" : "Mostrar senhas"}
          >
            {passwordIsVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </button>
        )}
        {type !== "file" && <label htmlFor={id}>{label + (required ? " *" : "")}</label>}
      </div>
    </div>
  );
};
